export function addRemoteVideoUser(user) {
  return {type: 'ADD_REMOTE_VIDEO_USER', user}
}

export function deleteRemoteVideoUser(user) {
  return {type: 'DELETE_REMOTE_VIDEO_USER', user}
}

export function initTableUser(user) {
  return {type: 'INIT_TABLE_USER', user}
}

export function updateTableUser(user) {
  return {type: 'UPDATE_TABLE_USER', user}
}

export function addTableUser(user) {
  return {type: 'ADD_TABLE_USER', user}
}

export function deleteTableUser(user) {
  return {type: 'DELETE_TABLE_USER', user}
}

export function initGroupUser(user) {
  return {type: 'INIT_GROUP_USER', user}
}

export function updateGroupUser(user) {
  return {type: 'UPDATE_GROUP_USER', user}
}

export function addGroupUser(user) {
  return {type: 'ADD_GROUP_USER', user}
}

export function deleteGroupUser(user) {
  return {type: 'DELETE_GROUP_USER', user}
}

export function initRaiseUser(user) {
  return {type: 'INIT_RAISE_USER', user}
}

export function updateRaiseUser(user) {
  return {type: 'UPDATE_RAISE_USER', user}
}

export function addRaiseUser(user) {
  return {type: 'ADD_RAISE_USER', user}
}

export function deleteRaiseUser(user) {
  return {type: 'DELETE_RAISE_USER', user}
}

export function initRemoteUser(user) {
  return {type: 'INIT_REMOTE_USER', user}
}

export function updateRemoteUser(user) {
  return {type: 'UPDATE_REMOTE_USER', user}
}

export function updateStream(user) {
  return {type: 'UPDATE_STREAM', user}
}

export function videoReset() {
  return {type: 'VIDEO_RESET'}
}

export function addRemoteUser(user) {
  return {type: 'ADD_REMOTE_USER', user}
}

export function deleteRemoteUser(user) {
  return {type: 'DELETE_REMOTE_USER', user}
}

export function fullScreen(user) {
  return {type: 'FULL_SCREEN', user}
}

export function audioMuteToggle(user,mute) {
  return {type: 'AUDIO_MUTE_TOGGLE', user,mute}
}

export function clearRemoteVideoUser() {
  return {type: 'CLEAR_REMOTE_VIDEO_USER'}
}

export function updateHear(group, hear) {
  return {type: 'UPDATE_HEAR', group, hear}
}


// WEBPACK FOOTER //
// ./src/routes/BreakOutMode/actions/index.js